import { useQuery } from "react-query"
import ProofOfOwnershipService from "~services/ProofOfOwnershipService"

const useProofOfOwnershipFile = (fileId: string, pooId?: string) => {
  return useQuery(
    ["proof-of-ownership-detail", fileId],
    () => ProofOfOwnershipService.getProofsOfOwnershipFile(fileId, pooId),
    {
      enabled: !!fileId,
    },
  )
}
export default useProofOfOwnershipFile
